import React from 'react';
import { formatValue, formatConfidence } from '../../utils/formatters';

const CustomerFitSection = ({ customerFitData, customerFitSignals, customerFitVisuals }) => {
    const { 
        hasCustomerFitRating, 
        hasCustomerFitConfidence, 
        hasCustomerFitSignals, 
        hasCustomerFitRecommendedMotion,
        customerFitRating,
        customerFitConfidence,
        customerFitRecommendedMotion
    } = customerFitData;

    if (!hasCustomerFitRating && !hasCustomerFitConfidence && !hasCustomerFitSignals && !hasCustomerFitRecommendedMotion) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Customer Fit</h4>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                    gap: '16px'
                }}
            >
                {(hasCustomerFitRating || hasCustomerFitConfidence) && (
                    <div
                        style={{
                            background: customerFitVisuals.gradient,
                            border: `1px solid ${customerFitVisuals.border}`,
                            borderRadius: '12px',
                            padding: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '14px',
                            boxShadow: `0 18px 36px ${customerFitVisuals.shadow}`
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            <span
                                style={{
                                    color: '#9ca3af',
                                    fontSize: '12px',
                                    letterSpacing: '0.08em',
                                    textTransform: 'uppercase',
                                    fontWeight: 600
                                }}
                            >
                                Overall Fit Rating
                            </span>
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                                <span
                                    style={{
                                        fontSize: '28px',
                                        fontWeight: 700,
                                        color: '#f9fafb'
                                    }}
                                >
                                    {hasCustomerFitRating ? formatValue(customerFitRating) : '—'}
                                </span>
                                {hasCustomerFitConfidence && (
                                    <span
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            color: '#f9fafc',
                                            backgroundColor: 'rgba(15, 23, 42, 0.35)',
                                            padding: '6px 12px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        Confidence {formatConfidence(customerFitConfidence)}
                                    </span>
                                )}
                            </div>
                        </div>
                        <span
                            style={{
                                color: customerFitVisuals.accent,
                                fontSize: '14px',
                                fontWeight: 600
                            }}
                        >
                            {customerFitVisuals.label}
                        </span>
                    </div>
                )}

                {hasCustomerFitSignals && (
                    <div
                        style={{
                            backgroundColor: '#2d2d2d',
                            border: '1px solid #404040',
                            borderRadius: '12px',
                            padding: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px'
                        }}
                    >
                        <span
                            style={{
                                color: '#9ca3af',
                                fontSize: '12px',
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                                fontWeight: 600
                            }}
                        >
                            Customer Fit Signals
                        </span>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {customerFitSignals.map((signal, index) => (
                                <div
                                    key={`${index}-${signal}`}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '10px'
                                    }}
                                >
                                    <span
                                        style={{
                                            width: '6px',
                                            height: '6px',
                                            borderRadius: '999px',
                                            backgroundColor: customerFitVisuals.accent,
                                            marginTop: '7px'
                                        }}
                                    />
                                    <span
                                        style={{
                                            fontSize: '14px',
                                            color: '#f3f4f6',
                                            lineHeight: 1.6
                                        }}
                                    >
                                        {formatValue(signal)}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {hasCustomerFitRecommendedMotion && (
                    <div
                        style={{
                            backgroundColor: '#2d2d2d',
                            border: '1px solid #404040',
                            borderRadius: '12px',
                            padding: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px'
                        }}
                    >
                        <span
                            style={{
                                color: '#9ca3af',
                                fontSize: '12px',
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                                fontWeight: 600
                            }}
                        >
                            Recommended Motion
                        </span>
                        <span
                            style={{
                                fontSize: '14px',
                                color: '#f3f4f6',
                                lineHeight: 1.6
                            }}
                        >
                            {formatValue(customerFitRecommendedMotion)}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomerFitSection;






